import './index.less';

import { Button } from '@bfe/moly';
import { Checkbox, message } from 'antd';
import React, { useState } from 'react';

import { useI18nContext } from '@/i18n/I18n';
import { copperAuth } from '@/services/apiManagement';

import ByModal from '../ByModal';

export enum ApiAuthScene {
  openApi = 1,
  subAccount = 2,
}

interface IProps {
  to: string;
  from: ApiAuthScene;
  text: string;
  accountTypeName: string;
  onSuccess: () => void;
  onCancel: () => void;
  onFail?: (error: any) => void;
}

const ApiAuthModal: React.FC<IProps> = ({
  to,
  from,
  text,
  accountTypeName,
  onSuccess,
  onFail,
  onCancel,
}) => {
  const [$t] = useI18nContext();
  const [auth, setAuth] = useState(false);

  const onSubmit = () => {
    if (auth) {
      copperAuth({ to, from })
        .then(() => {
          message.success($t('apiAuthModal.success'));
          onSuccess?.();
        })
        .catch((error) => {
          if (onFail) {
            onFail(error);
          } else {
            message.error($t('apiAuthModal.error'));
          }
        });
    }
  };

  return (
    <ByModal
      visible
      ByFooter={[
        <div key="apiAuthCheckbox" className="api-auth-modal__checkbox">
          <Checkbox
            checked={auth}
            onChange={(e) => {
              setAuth(e.target.checked);
            }}
          >
            {$t('apiAuthModal.copper.confirmTextNew').replace(
              '{{name}}',
              $t(accountTypeName),
            )}
          </Checkbox>
        </div>,
        <Button
          onClick={onSubmit}
          disabled={!auth}
          variant="primary"
          key="confirmBtn"
          block
          className="bybit-btn-primary"
        >
          {$t('confirm')}
        </Button>,
      ]}
      onCancel={onCancel}
      title={$t('apiAuthModal.title')}
      newStyle
    >
      <p className="api-auth-modal__text">{text}</p>
    </ByModal>
  );
};

export default ApiAuthModal;
